import * as API from "middleware/api";

export const listMetrocorp = (
    optionSelected,
    principalAccount,
    species,
    date,
    dateFrom,
    dateTo,
    page,
    directionFilter,
) =>
    API.executeWithAccessToken("/metrocorp.list", {
        optionSelected,
        principalAccount,
        species,
        date,
        dateFrom,
        dateTo,
        page,
        directionFilter,
    });

export const listMetrocorpPre = () => API.executeWithAccessToken("/metrocorp.list.pre");

export const downloadList = (summary, format) =>
    API.executeWithAccessToken("/metrocorp.downloadList", { summary, format });

export const getDetail = (reference) => API.executeWithAccessToken("/metrocorp.detail", { reference });

export const downloadDetail = (detail, format) =>
    API.executeWithAccessToken("/metrocorp.downloadDetail", { detail, format });

export const downloadDetailByReference = (reference, format) =>
    API.executeWithAccessToken("/metrocorp.downloadDetail.reference", { reference, format });

export const downloadMonthlyReport = (reportDrawerValues) =>
    API.executeWithAccessToken("/metrocorp.download.monthly.report", reportDrawerValues);

export const listHoldings = (params = {}) => API.executeWithAccessToken("/metrocorp.holdings", params);

export const downloadPerformance = (account, date, verifyCode) =>
    API.executeWithAccessToken("/metrocorp.downloadPerformance", {
        account,
        date,
        verifyCode,
        format: "xls",
    });

export const listMovements = (params = {}) => API.executeWithAccessToken("/metrocorp.movements", params);

export const downloadBoleto = ({ formulario, numero, idBoleto, account, verifyCode, date }) =>
    API.executeWithAccessToken("/metrocorp.downloadBoleto", {
        formulario,
        numero: numero == null ? numero : String(numero),
        idBoleto: idBoleto == null ? idBoleto : String(idBoleto),
        account,
        verifyCode,
        date,
    });
